<template>
  <div>
    <filter-slot
      :filter="filters"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="$refs['ref-table-monitoring-detail-report'].refresh()"
    >
      <template #buttons>
        <v-select
          style="width: 200px"
          class="ml-2"
          :options="years"
          v-model="yearSelected"
        />
        <b-button variant="primary" class="ml-1">
          <feather-icon icon="SearchIcon" />
        </b-button>
      </template>
      <template #table>
        <b-table
          ref="ref-table-monitoring-detail-report"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative"
          table-class="text-nowrap"
          :busy.sync="isBusy"
          :items="myProvider"
          :fields="showFields"
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>
          <template #cell(code)="data">
            <div class="d-flex">
              <div class="pt-1">
                <feather-icon
                  v-if="data.item.personal_type == 'Driver'"
                  icon="TruckIcon"
                  size="22"
                  class="text-warning"
                />
                <feather-icon
                  v-else
                  icon="UserIcon"
                  size="22"
                  class="text-success"
                />
              </div>
              <div class="ml-1">
                <span> {{ data.item.personal_name | capitalize }} </span><br />
                <span style="opacity: 0.5; margin-bottom: 10px">
                  #{{ data.item.code }} </span
                ><br />
                <hr class="m-0" />
                Status:
                <b-badge
                  class="ml-2"
                  pill
                  :variant="`light-${
                    data.item.status == 'Active' ? 'success' : 'danger'
                  }`"
                >
                  <span>{{ data.item.status | capitalize }}</span> </b-badge
                ><br />
                <hr class="m-0" />
                Viatico:
                <b-badge
                  class="ml-2"
                  pill
                  :variant="`light-${
                    data.item.is_viatic == 'Apply' ? 'success' : 'danger'
                  }`"
                >
                  <span>{{ data.item.is_viatic | capitalize }}</span> </b-badge
                ><br />
                <hr class="m-0" />
                Subgrupo:
                <span style="opacity:0.7"> {{ data.item.entity_group_name | capitalize }} </span>
              </div>
            </div>
          </template>
          <template #cell()="data">
            <template v-for="(item, key) in data.value">
              <div
                style=""
                :key="key + item.num + data.item.code"
                v-if="key != 'month' && key != 'num' && key != 'total'"
              >
                <b-avatar size="sm" rounded :variant="resolvColor(key)">
                  <span class="text-uppercase"> {{ key }} </span>
                </b-avatar>
                <span> : {{ data.value[key] }} </span>
                <hr class="m-0" />
              </div>
            </template>
            <hr class="m-0" />
            <hr class="m-0" />
            <b-avatar size="sm" rounded variant="light-warning">
              <span class="text-uppercase"> #</span>
            </b-avatar>
            <span> : {{ data.value.total }} </span>
          </template>
        </b-table>
      </template>
    </filter-slot>

    <AttendanceDetailsByStatus
      v-if="attendanceDetailsByStatus"
      :dataModal="dataModal"
      @hideModal="hideAttendanceDetailsByStatus"
    />

    <PersonalAttendance
      v-if="personalAttendance"
      :dataModal="dataModal"
      @hideModal="hidePersonalAttendance"
    />

    <!-- <b-button @click="process">Process</b-button>
    <b-button @click="send">Send</b-button>
    <pre>
      {{ items }}
    </pre> -->
    <!-- <b-table :items="items" small responsive> </b-table> -->
  </div>
</template>

<script>
/* COMPONENTS */
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";

/* DATA */
import Filters from "@/views/monitoring/views/reports/data/filters-year.data.js";
import Fields from "@/views/monitoring/views/reports/data/fields-year.js";

/* Modals */
import AttendanceDetailsByStatus from "@/views/monitoring/views/attendance/components/modals/AttendanceDetailsByStatus.vue";
import PersonalAttendance from "@/views/monitoring/views/attendance/components/modals/PersonalAttendance.vue";

/* Services */
import AttendanceService from "@/views/monitoring/views/attendance/services/attendance.service.js";
import ReportsService from "@/views/monitoring/views/reports/services/reports.service.js";
import EmployeeService from "@/views/rrhh/views/employees/services/employee.service.js";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {
    FilterSlot,
    AttendanceDetailsByStatus,
    PersonalAttendance,
  },
  data() {
    return {
      filters: [...Filters],
      // items: Usuarios,
      params: 1,
      fields: [...Fields],
      isBusy: false,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Search...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      years: [],
      yearSelected: moment().format("YYYY"),
      attendanceDetailsByStatus: false,
      personalAttendance: false,
      dataModal: {},
    };
  },
  computed: {
    showFields() {
      //   return Fields.map(item => ({ ...item, label: this.$t(item.label) }));
      return this.fields.filter((item) => item.visible);
    },
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
  },
  created() {
    this.getYears();
    this.getEntityGroups();
  },
  methods: {
    getYears() {
      this.years = ["2019", "2020", "2021", "2022", "2023", "2024", "2025", "2026"];
    },

    async myProvider(ctx) {
      try {
        this.addPreloader();
        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          search_txt: this.filterPrincipal.model,
          year: this.yearSelected,
          personal_type: this.filters[0].model,
          is_viatic: this.filters[1].model,
          entity_group_id: this.filters[2].model,
          status: this.filters[3].model != null ? this.filters[3].model : 1,
          // attendance_status: this.filters[4].model,
        };
        const { data } = await ReportsService.getYearAttendanceReport(params);
        this.paginate.from = data.from;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.perPage = data.per_page;
        this.paginate.currentPage = data.current_page;
        return data.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    async getEntityGroups() {
      const { data } = await EmployeeService.getEntitiesGroup();
      this.filters[2].options = data;
    },
    homeworkStatusVariant(homework_status_id) {
      if (homework_status_id == null) return "default";
      if (homework_status_id === 3) return "danger";
      if (homework_status_id === 4) return "warning";
      if (homework_status_id === 1 || homework_status_id === 2)
        return "success";
      if (homework_status_id === "inactive") return "secondary";
      return "primary";
    },
    countHomeworkStatusVariant(count) {
      if (count === 0) return "success";
      if (count > 0 && count <= 3) return "warning";
      return "danger";
    },
    todayRecord(attendance_id, today, item) {
      this.dataModal = {
        attendance_id,
        personal_name: item.personal_name,
        code: item.code,
        today,
      };
      this.attendanceDetailsByStatus = true;
    },
    getAttendanceDetailsByStatus(
      attendance_id,
      homework_status_id,
      count,
      item
    ) {
      if (count == 0) return;
      this.dataModal = {
        attendance_id,
        homework_status_id,
        personal_name: item.personal_name,
        code: item.code,
      };
      this.attendanceDetailsByStatus = true;
    },
    hideAttendanceDetailsByStatus() {
      this.attendanceDetailsByStatus = false;
    },
    setAttendance(item) {
      this.dataModal = item;
      this.dataModal.origin = "attendance";
      this.personalAttendance = true;
    },
    hidePersonalAttendance(action = false) {
      if (action == true) {
        this.$refs["ref-table-monitoring-detail-report"].refresh();
      }
      this.personalAttendance = false;
    },
    resolvColor(homework_status_id) {
      if (homework_status_id == null) return "light-warning";
      switch (homework_status_id) {
        case "lc":
          return "light-primary";
          break;
        case "ru":
          return "light-success";
          break;
        case "fa":
          return "light-danger";
          break;
          case "ta":
          return "light-danger";
          break;
          case "do":
          return "light-warning";
          break;
          case "dl":
          return "light-warning";
          break;
        default:
          return "light-info";
          break;
      }
    },
  },
};
</script>

<style>
</style>